import {NgModule} from '@angular/core';
import {DatePipe, DecimalPipe} from '@angular/common';
import {PricesComponent} from './components/boot/prices.component';
import {PriceChangesComponent} from './components/price-changes/price-changes.component';
import {ChangelogComponent} from './components/changelog/changelog.component';
import {PricesViewRouterModule} from './prices-view-router.module';
import {VerityPricesTableComponent} from './components/verity-prices-table/verity-prices-table.component';
import {NetPricesComponent} from './components/net-prices/net-prices.component';
import {UnitPricesComponent} from './components/unit-prices/unit-prices.component';
import {TableViewComponent} from '../utils/components/table-view/table-view.component';
import {CurrencyConverterPipe} from '../utils/pipes/currency-converter.pipe';
import {VpColumnFilterPipe} from '../utils/pipes/vp-column-filter.pipe';
import {TableChartComponent} from '../utils/components/table-chart/table-chart.component';
import {GlobalCommonModule} from '../boot/global-common.module';
import {InlineEditComponent} from '../utils/components/change-currency-dialog/inline-edit/inline-edit.component';
import {DecimalConverter} from '../utils/pipes/decimal-converter';
import {MatChipsModule, MatExpansionModule, MatIconModule} from '@angular/material';
import {DynamicFilterComponent} from '../utils/components/dynamic-filter/dynamic-filter.component';
import { NgxChartsModule } from 'projects/ngx-charts/src/lib';
import { GroupedChartComponent } from 'projects/ngx-charts/src/lib/grouped-chart/grouped-chart.component';

@NgModule({
  declarations: [
    VerityPricesTableComponent,
    TableViewComponent,
    InlineEditComponent,

    // Inner Components
    PricesComponent,
    PriceChangesComponent,
    ChangelogComponent,
    NetPricesComponent,
    UnitPricesComponent,
    TableChartComponent,
    GroupedChartComponent,
    DynamicFilterComponent,

    // Pipes
    VpColumnFilterPipe,
    CurrencyConverterPipe,
    DecimalConverter,
  ],
  imports: [
    PricesViewRouterModule,
    GlobalCommonModule,
    MatExpansionModule,
    MatChipsModule,
    MatIconModule,
    NgxChartsModule,
  ],
  exports: [
    VpColumnFilterPipe,
    InlineEditComponent,
    CurrencyConverterPipe,
    TableViewComponent,
    GlobalCommonModule,
    DecimalConverter
  ],
  providers: [
    DatePipe,
    CurrencyConverterPipe,
    VpColumnFilterPipe
  ]
})
export class PricesViewModule {
}
